/** Display structured fields pulled from payment receipt AI review. */

const pickExtracted = (ocr) => {
  if (!ocr) return null;
  const ex = ocr.extracted || {};
  const source = ocr.payment_source || ex.payment_source;
  const utrs = ocr.utrs || ocr.transaction_ids || ex.utrs || ex.transaction_ids || [];
  const accounts = ocr.account_numbers || ex.account_numbers || [];
  const ifsc = ocr.ifsc_codes || ex.ifsc_codes || [];
  const upi = ocr.upi_ids || ex.upi_ids || [];
  const sender = ocr.sender_name || ex.sender_name;
  const receiver = ocr.receiver_name || ex.receiver_name;
  const banks = ocr.bank_names || ex.bank_names || [];

  const rows = [];
  if (source) rows.push({ label: 'Source', value: source });
  if (utrs.length) rows.push({ label: 'UTR / Txn ID', value: utrs.slice(0, 4).join(', ') });
  if (accounts.length) rows.push({ label: 'Account No', value: accounts.slice(0, 4).join(', ') });
  if (ifsc.length) rows.push({ label: 'IFSC', value: ifsc.slice(0, 3).join(', ') });
  if (upi.length) rows.push({ label: 'UPI ID', value: upi.slice(0, 3).join(', ') });
  if (sender) rows.push({ label: 'From', value: sender });
  if (receiver) rows.push({ label: 'To', value: receiver });
  if (banks.length) rows.push({ label: 'Bank', value: banks.slice(0, 3).join(', ') });
  return rows.length ? rows : null;
};

export default function ReceiptExtractedFields({ ocrResult }) {
  const rows = pickExtracted(ocrResult);
  if (!rows) return null;

  return (
    <div className="mt-2 rounded-lg border border-orange-100/80 bg-white/70 px-2.5 py-2">
      <div className="text-[10px] font-semibold uppercase tracking-wide text-orange-800/80 mb-1.5">
        Extracted from receipt
      </div>
      <dl className="grid grid-cols-1 gap-1">
        {rows.map((row) => (
          <div key={row.label} className="flex gap-2 text-[11px] leading-snug">
            <dt className="shrink-0 w-[88px] text-gray-500">{row.label}</dt>
            <dd className="font-medium text-gray-900 break-all">{row.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
